import { Autocomplete } from "@mui/material";
import { NodeInterface } from "../../modules/tables/schemas/nodes";
import TextField from "@mui/material/TextField";


export interface NodeSelectorProps {
    nodes: NodeInterface[];
    inputValue: NodeInterface | null;
    setInputValue: (node: NodeInterface | null) => void;
    label: string;
}

const NodeSelector = (props: NodeSelectorProps) => {
    return (
        <Autocomplete
            size="small"
            id="node-selector"
            sx={{ my: 0, mr: 1 }}
            autoHighlight
            fullWidth
            options={props.nodes}
            renderOption={(props, option) => {
                return (
                    <li {...props} key={option.id}>
                        {option.name}
                    </li>
                );
            }}
            getOptionLabel={(option: NodeInterface) => option.name}
            value={props.inputValue}
            onChange={(e, value) => {
                props.setInputValue(value);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    slotProps={{
                        inputLabel: {
                            shrink: true,
                        },
                    }}
                />
            )}
        />
    );
};


export default NodeSelector;
